"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeQueryParams = void 0;
function makeQueryParams(params) {
    return Object.entries(params)
        .filter(([, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
}
exports.makeQueryParams = makeQueryParams;
//# sourceMappingURL=query-params.js.map